import { render, staticRenderFns } from "./iTag.vue?vue&type=template&id=0219c1e0&lang=pug"
import script from "./iTag.vue?vue&type=script&lang=js"
export * from "./iTag.vue?vue&type=script&lang=js"
import style0 from "./iTag.vue?vue&type=style&index=0&id=0219c1e0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports